import { apiRequest } from "../services/apiRequest";

export const Campaigns = {
  getCampaignsList: async ({
    search = "",
    type = "",
    status = "",
    page = 1,
    pageSize = 10,
  } = {}) => {
    const queryParams = new URLSearchParams();

    if (search) queryParams.set("search", search);
    if (type && type !== "All Types") queryParams.set("type", type);
    if (status && status !== "All Status") queryParams.set("status", status);
    queryParams.set("page", page);
    if (pageSize) queryParams.set("page_size", pageSize);

    const queryString = queryParams.toString();
    const url = `/account/campaigns/${queryString ? `?${queryString}` : ""}`;

    return await apiRequest("get", url);
  },

  createCampaign: async (payload) => {
    // If payload is FormData, use different headers
    if (payload instanceof FormData) {
      return await apiRequest("post", `/account/campaigns/`, payload);
    }
    return await apiRequest("post", `/account/campaigns/`, payload);
  },

  getUsersCount: async () => {
    return await apiRequest("get", `/account/campaigns/users_count/`);
  },

  deleteCampaign: async (campaignId) => {
    return await apiRequest("delete", `/account/campaigns/${campaignId}/`);
  },

  updateCampaign: async (campaignId, payload) => {
    // If payload is FormData, use different headers
    if (payload instanceof FormData) {
      return await apiRequest("patch", `/account/campaigns/${campaignId}/`, payload);
    }
    return await apiRequest("patch", `/account/campaigns/${campaignId}/`, payload);
  },

  getCampaignById: async (campaignId) => {
    return await apiRequest("get", `/account/campaigns/${campaignId}/`);
  },

  getUserList: async (campaignId, page = 1, filters = {}) => {
    const queryParams = new URLSearchParams();
    queryParams.set("campaign_id", campaignId);
    queryParams.set("page", page);
    
    // Add search and filter parameters if provided
    if (filters.name) queryParams.set("name", filters.name);
    if (filters.status) queryParams.set("status", filters.status);
    if (filters.plan) queryParams.set("plan", filters.plan);
    if (filters.country) queryParams.set("country", filters.country);
    
    return await apiRequest("get", `/account/campaigns/get_user_list/?${queryParams.toString()}`);
  },

  deleteExcel: async (filePath) => {
    return await apiRequest("post", `/account/campaigns/delete_excel/`, {
      file_path: filePath,
    });
  },

  getContactUsersList: async ({ contact = null, contact_user_name = null, campaign_id = null, page = 1, pageSize = 10 } = {}) => {
    const queryParams = new URLSearchParams();
    if (contact) queryParams.set("contact_filter", contact);
    if (campaign_id) queryParams.set("campaign_id", campaign_id);
    
    if (contact_user_name) {
      // When searching, only add search parameter, no pagination
      queryParams.set("contact_user_name", contact_user_name);
    } else {
      // When not searching, add pagination
      queryParams.set("page", page);
      if (pageSize) queryParams.set("page_size", pageSize);
    }

    const queryString = queryParams.toString();
    const url = `/account/campaigns/list_contact_users/${queryString ? `?${queryString}` : ""}`;

    return await apiRequest("get", url);
  },

  getContactGroupsList: async ({ campaign_id, contact_name = null, page = 1, pageSize = 10 } = {}) => {
    const queryParams = new URLSearchParams();
    if (campaign_id) queryParams.set("campaign_id", campaign_id);
    
    if (contact_name) {
      // When searching, only add search parameter, no pagination
      queryParams.set("contact_name", contact_name);
    } else {
      // When not searching, add pagination
      queryParams.set("page", page);
      if (pageSize) queryParams.set("page_size", pageSize);
    }

    const queryString = queryParams.toString();
    const url = `/account/campaigns/list_contact_groups/${queryString ? `?${queryString}` : ""}`;

    return await apiRequest("get", url);
  },

  uploadCampaignExcel: async (file) => {
    const formData = new FormData();
    formData.append("file", file);
    const response = await apiRequest("post", `/account/campaigns/upload_campaign_excel/`, formData);
    return response.data;
  },

  getCampaignSummary: async (campaignId, { skipCache = false } = {}) => {
    return await apiRequest(
      "get",
      `/account/campaigns/${campaignId}/view_summary/`,
      undefined,
      { skipCache }
    );
  },

  getFailedEmails: async (campaignId, { search = "", page = 1, pageSize = 10 } = {}) => {
    const queryParams = new URLSearchParams();
    if (search) queryParams.set("search", search);
    queryParams.set("page", page);
    if (pageSize) queryParams.set("page_size", pageSize);

    // Always bypass the short-lived GET cache: this list changes right after a delete.
    return await apiRequest(
      "get",
      `/account/campaigns/${campaignId}/failed_emails/?${queryParams.toString()}`,
      undefined,
      { skipCache: true }
    );
  },

  deleteFailedEmails: async (campaignId, { emails = null, all = false } = {}) => {
    const payload = all ? { all: true } : { emails };
    return await apiRequest(
      "post",
      `/account/campaigns/${campaignId}/delete_failed_emails/`,
      payload
    );
  },
};

